import {combineReducers} from 'redux';
import {routerReducer} from 'react-router-redux';
import {reducer as formReducer} from 'redux-form';
import {reducer as flashReducer} from 'redux-flash';
import {i18nReducer} from 'react-redux-i18n';
import user from '../../../../core/store/reducers/user';
import layout from './layout';
import workspace from '../../../../core/store/reducers/workspace';
import menu from './../../../../core/store/reducers/menu';
import media from './media';
import contentdefinition from './../../../../core/store/reducers/contentdefinition';
import fielddefinition from './../../../../core/store/reducers/fielddefinition';
import language from './../../../../core/store/reducers/language';
import content from './../../../../core/store/reducers/content';
import block from './../../../../core/store/reducers/block';
import preview from './preview';
import global from './../../../../core/store/reducers/global';
import widgets from './../../../../core/store/reducers/widgets';
import features from './features';
import division from './division';
import publicForms from "./publicForms";

const reducers = combineReducers({
    user: user,
    layout: layout,
    workspace: workspace,
    menu: menu,
    media: media,
    contentdefinition: contentdefinition,
    fielddefinition: fielddefinition,
    language: language,
    content: content,
    block: block,
    form: formReducer,
    flash: flashReducer,
    routing: routerReducer,
    i18n: i18nReducer,
    preview: preview,
    global: global,
    widgets: widgets,
    features: features,
    division: division,
    publicForms: publicForms
});

export default reducers;



// WEBPACK FOOTER //
// ./src/core/admin/store/reducers/index.js